<template>
  <div class="actions-collapsed-list">
    <a
      class="btn btn-function exit-collapsed-list"
      @click="collapseActions"
    >
      <i
        class="glyphicon glyphicon-chevron-left"
        aria-hidden="true"
        tooltip-placement="right"
        uib-tooltip="Cancel"
      />
    </a>

    <div
      v-if="user.email !== currentUserName"
      class="action-icon"
    >
      <a
        :disabled="disabled"
        class="btn btn-list-function"
        @click="openDeleteModal"
      >
        <i
          v-tooltip.bottom.hover="user.hasUser ? {text:$t('TT_ACTION_REMOVE_USER'), transition: 0} :{text:$t('TT_ACTION_REMOVE_INVITATION'), transition: 0}"
          class="typcn typcn-trash"
          aria-hidden="true"
        />
        <span
          v-t="'DELETE'"
          class="hint-text-mobile"
        />
      </a>
    </div>
    <div
      v-if="user.hasInvite && !user.hasUser && user.invite.url"
      class="action-icon"
    >
      <a
        v-clipboard="{ copyText: user.invite.url }"
        :disabled="disabled"
        class="btn btn-list-function"
        @click="onCopiedInviteUrl"
      >
        <i
          v-tooltip.bottom.hover="$t('TT_ACTION_COPY_INVITE')"
          class="typcn typcn-code"
          aria-hidden="true"
        />
        <span
          v-t="'TT_ACTION_COPY_INVITE'"
          class="hint-text-mobile"
        />
      </a>
    </div>

    <ConfirmationModal 
      v-if="showDeleteInviteModal"
      :title="$t('TITLE_DELETE_INVITE')"
      :cancel-button-text="$t('CANCEL')"
      :confirm-action-text="$t('DELETE')"
      :show-header-close-button="false"
      :confirm-button-loading="isDeletePending"
      :cancel-button-disabled="isDeletePending"
      @confirm="deleteInvite"
      @close="hideModal"
    >
      <p
        v-text="$t('LABEL_DELETE_INVITE_MODAL_MESSAGE', { userName: user.name })"
      />
      <p 
        v-text="$t('LABEL2_DELETE_INVITE_MODAL_MESSAGE')"
      />
    </ConfirmationModal>

    <ConfirmationModal 
      v-if="showDeleteUserModal"
      :title="$t('TITLE_DELETE_USER')"
      :cancel-button-text="$t('CANCEL')"
      :confirm-action-text="$t('DELETE')"
      :show-header-close-button="false"
      :confirm-button-loading="isDeletePending"
      :cancel-button-disabled="isDeletePending"
      @confirm="deleteUser"
      @close="hideModal"
    >
      <p
        v-text="$t('LABEL_DELETE_USER_MODAL_MESSAGE', { userName: user.name })"
      />
    </ConfirmationModal>
  </div>
</template>

<script>
import messages from '../locales';
import sharedMessages from '@/core/locales';
import { accountsService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { mapGetters } from 'vuex';
import { STATUS_PENDING } from '@/store/helpers';
import ConfirmationModal from '@/core/components/ConfirmationModal/ConfirmationModal';

export default {
  name: 'UsersActions',
  components: {
    ConfirmationModal
  },
  props:{
    user: {
      type: Object,
      default() {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showDeleteInviteModal: false,
      showDeleteUserModal: false
    };
  },
  computed: {
    ...mapGetters('users', [
      'deleteUserStatus',
      'deleteInviteStatus']
    ),
    currentUserName() { 
      return accountsService.currentUserName; 
    },
    isDeletePending() {
      return this.deleteInviteStatus?.status === STATUS_PENDING ||
             this.deleteUserStatus?.status === STATUS_PENDING;
    },
  },
  methods:{
    collapseActions() {
      this.$emit('collapse-actions', this.user.id);
    },
    openDeleteModal() {
      if (!this.disabled) {
        if (this.user.hasUser && this.user.email !== this.currentUserName) {
          this.showDeleteUserModal = true;
        } else {
          this.showDeleteInviteModal = true;
        }
      }
    },
    hideModal() {
      this.showDeleteUserModal = false;
      this.showDeleteInviteModal = false;
      this.showModalId = null;
      this.showModalName = null;
    },
    deleteUser() {
      this.$emit('delete-user', this.user.id);
    },
    deleteInvite() {
      this.$emit('delete-invite', this.user.id);
    },
    onCopiedInviteUrl() {
      this.$emit('copied-invitation-url');
    },
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>

<style lang="scss">
form.user {
  .multi-select-lg {
    width: 100%;
  }

  .v-select .vs__selected {
    height: 32px;
    padding: 8px 8px 7px 10px;
    border-bottom: 1px solid transparent;
  }
}
</style>